import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

import {
  IqObservationCounts,
  IqRateOfChangeSummary,
  IqRateOfChange,
} from '../../domain/iq-aggregated-dashboard.model';
import {
  IQ_TILE_DEFINITIONS,
  IqActionLabelId,
} from 'src/app/shared/constants/iq-observation-action-labels';

interface Tile {
  label: string;
  count: number;
  rate: IqRateOfChange | null;
  accentBarClass: string;
  accentTextClass: string;
  actionLabelId: IqActionLabelId;
}

@Component({
  selector: 'app-iq-observation-tiles',
  templateUrl: './iq-observation-tiles.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule, RouterLink],
})
export class IqObservationTilesComponent {
  readonly observationCounts = input<IqObservationCounts | undefined>();

  readonly rateOfChange = input<IqRateOfChangeSummary | undefined>();

  readonly tiles = computed<Tile[]>(() => {
    const counts = this.observationCounts();
    if (counts == null) return [];

    const roc = this.rateOfChange();

    return IQ_TILE_DEFINITIONS.map((def) => ({
      label: def.label,
      count: counts[def.countKey],
      rate: roc?.[def.countKey] ?? null,
      accentBarClass: def.accentBarClass,
      accentTextClass: def.accentTextClass,
      actionLabelId: def.actionLabelId,
    }));
  });

  getTrendIcon(rate: IqRateOfChange | null): string {
    if (rate == null || rate.direction === 'flat') return 'trending_flat';
    return rate.direction === 'up' ? 'trending_up' : 'trending_down';
  }

  getTrendClass(rate: IqRateOfChange | null): string {
    if (rate == null || rate.direction === 'flat') return 'text-gray-500';
    return rate.direction === 'up' ? 'text-red-500' : 'text-green-600';
  }
}
